// @flow

import styled from '@emotion/styled'
import { Link } from 'gatsby'
import * as React from 'react'
import { Helmet } from 'react-helmet'

import { colors, fonts, media } from '@toggl/style'
import { Button, Global, text } from '@toggl/ui'
import { LayoutRoot } from 'components/layouts'

import image from './404Image.svg'

export default function NotFoundPage() {
  return (
    <LayoutRoot
      title='Page Not Found | Toggl'
      ogImage={require('assets/toggl-global-main.jpg').default}
    >
      <Helmet>
        <meta name='robots' content='noindex, follow' />
      </Helmet>
      <Link to='/'>
        <IconWrapper>
          <Global />
        </IconWrapper>
      </Link>
      <ContentWrapper>
        <Text>
          <Header color={colors.orange10}>Oops!</Header>
          <Paragraph>
            It seems like that's not what you were looking for.
          </Paragraph>
          <Link to='/'>
            <Button.Primary>Go home</Button.Primary>
          </Link>
        </Text>
        <Image src={image} />
      </ContentWrapper>
    </LayoutRoot>
  )
}

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin-left: 32px;
  margin-top: 140px;

  ${media.mq[1]} {
    flex-direction: row;
    justify-content: center;
  }
`

const IconWrapper = styled.div`
  position: fixed;
  left: 32px;
  top: 32px;
  height: 42px;

  svg {
    height: 100%;
  }
`

const Header = styled(text.H1)`
  font-family: ${fonts.gtHaptikMediumRotalic};
  margin-bottom: 32px;
`

const Paragraph = styled(text.P1)`
  margin-bottom: 40px;
`

const Text = styled.div`
  ${media.mq[1]} {
    max-width: 320px;
  }
`

const Image = styled.img`
  margin-top: 60px;
  margin-right: 32px;

  ${media.mq[1]} {
    margin-top: 0;
    margin-left: 50px;
    width: auto;
    height: 55vh;
    transform: translateY(7%);
  }

  ${media.mq[2]} {
    margin-left: 150px;
  }
`
